import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80fde306"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "form-label"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed, ref, watch, PropType } from 'vue';
import i18n from "@/i18n/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'MonthField',
  props: {
  modelValue: {
    type: Object,
    default: null,
  },
  readonly: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  label: { type: String },
  v: { type: Object }, // validation object
  
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

// Internal value to bind to VueDatePicker
const internalValue = ref<Object | null>(props.modelValue);

 

// Watch internal value and emit YYYY-MM string
watch(internalValue, (newValue) => {
  emits('update:modelValue', newValue); // string or null
});

// Watch prop updates
watch(() => props.modelValue, (newValue) => {
  internalValue.value = newValue;
});

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createElementVNode("b", null, _toDisplayString(__props.label), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_VueDatePicker, {
      modelValue: internalValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
      disabled: __props.disabled,
      readonly: __props.readonly,
      type: "month",
      locale: "fr",
      cancelText: _unref(i18n).t('button.cancel'),
      selectText: _unref(i18n).t('button.select'),
      "enable-time-picker": false,
      "month-picker": ""
    }, null, 8, ["modelValue", "disabled", "readonly", "cancelText", "selectText"]),
    (__props.v)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "text-danger",
              key: error.$uid
            }, [
              _createTextVNode(" - " + _toDisplayString(error.$message) + " ", 1),
              _hoisted_4
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})